import { Grid } from '@mui/material';
import { RequestsType, RequestVM } from 'civil-status/view-models/step-form';
import { memo } from 'react';
import ComponentToRequest from './component-to-request';

interface FormRequestsProps {
  requests?: RequestsType;
  disabled?: boolean;
}

const FormRequestsComponent = ({ requests, disabled }: FormRequestsProps): React.ReactElement => {
  const questionsToShow: Array<RequestVM> = requests?.requests || [];

  return (
    <Grid item xs={12} container spacing={2}>
      {questionsToShow.map((item) => (
        <Grid
          item
          xs={12}
          md={6}
          key={`${item.type}-${item.request}`}
          style={{ display: 'flex', alignItems: 'flex-end' }}
        >
          <ComponentToRequest request={item} disabled={disabled} />
        </Grid>
      ))}
    </Grid>
  );
};

FormRequestsComponent.displayName = 'Form Requests Component';

const FormRequests = memo(FormRequestsComponent);

export default FormRequests;
